import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import { QcResponse } from '../../../../shared/models/qcResponse.model';
import { SearchTag } from '../models/search-filters.model';

export const OpenUpdateTagDialog = createAction(
  '[Data Customization: Tag Management Update]: Open Update Tag Dialog',
  props<{ row: SearchTag }>(),
);

export const UpdateTagLabelChanged = createAction(
  '[Data Customization: Tag Management Update]: Tag Label Changed',
  props<{ updateTagLabel: string }>(),
);

export const UserSubmitted = createAction('[Data Customization: Tag Management Update]: User Submitted');

export const UpdateTag = createAction('[Data Customization: Tag Management Update]: Updating Tag');

export const UpdateTagSuccess = createAction(
  '[Data Customization: Tag Management Update]: Update Tag Success',
  props<{ res: QcResponse }>(),
);

export const UpdateTagFailed = createAction(
  '[Data Customization: Tag Management Update]: Update Tag Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const CloseUpdateDialog = createAction('[Data Customization: Tag Management Update]: Close Update Dialog');
